import dimensions from "../generated/question_images.json"

// Figuras de questão: dimensões, zoom no toque e queda elegante quando o arquivo
// não existe.
//
// O zoom e o tratamento de erro são instalados como listeners no document, não
// como props de React, porque a figura chega por DOIS caminhos: <img> renderizada
// pelo QuestionContent (React) e <img> injetada como HTML pelo RichContent
// (dangerouslySetInnerHTML, onde não há como pendurar handler de React).

// O JSON gerado tipa como number[]; a leitura abaixo já trata par incompleto.
const DIMENSOES = dimensions as Record<string, number[]>

export const IMG_CLASS =
  "questao-figura my-3 block max-w-full cursor-zoom-in rounded-lg border border-slate-200 bg-white"

/** Dimensões reais do PNG, do manifesto gerado por `rails questoes:manifest`. */
export function imageSize(name: string): { width?: number; height?: number } {
  const par = DIMENSOES[name.trim()]
  if (!par || par.length < 2 || !par[0] || !par[1]) return {}
  return { width: par[0], height: par[1] }
}

/**
 * Atributos da figura como string HTML (caminho do RichContent).
 * width/height evitam o salto de layout enquanto a imagem carrega.
 */
export function imageAttrs(name: string): string {
  const { width, height } = imageSize(name)
  const tamanho = width && height ? ` width="${width}" height="${height}"` : ""
  return `${tamanho} loading="lazy" class="${IMG_CLASS}"`
}

function figuraIndisponivel(img: HTMLImageElement) {
  // Ícone quebrado no meio de uma prova cronometrada é pior do que dizer que a
  // figura falhou: o candidato precisa saber que não é problema dele.
  const aviso = document.createElement("p")
  aviso.className =
    "my-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800"
  aviso.textContent = "Figura indisponível — avise o suporte se esta questão depender dela."
  img.replaceWith(aviso)
}

function abrirZoom(img: HTMLImageElement) {
  const overlay = document.createElement("div")
  overlay.className =
    "fixed inset-0 z-50 flex items-center justify-center overflow-auto bg-navy-950/80 p-4"
  overlay.setAttribute("role", "dialog")
  overlay.setAttribute("aria-label", "Figura ampliada")

  const ampliada = document.createElement("img")
  ampliada.src = img.src
  ampliada.alt = img.alt
  // min-w força a figura pequena (a mediana tem 428px) a ocupar a tela e ficar
  // legível; overflow no overlay permite arrastar quando estoura.
  ampliada.className = "min-w-[min(150vw,900px)] max-w-none cursor-zoom-out rounded-lg bg-white"

  const fechar = document.createElement("button")
  fechar.type = "button"
  fechar.textContent = "Fechar"
  fechar.className =
    "fixed right-4 top-4 rounded-lg bg-white/90 px-4 py-2 text-sm font-semibold text-navy-900"

  const encerrar = () => {
    overlay.remove()
    document.removeEventListener("keydown", aoTeclar)
  }
  const aoTeclar = (e: KeyboardEvent) => {
    if (e.key === "Escape") encerrar()
  }

  overlay.addEventListener("click", encerrar)
  document.addEventListener("keydown", aoTeclar)
  overlay.append(ampliada, fechar)
  document.body.appendChild(overlay)
}

let instalado = false

/** Idempotente: pode ser chamado por qualquer entrypoint (SPA e admin). */
export function installQuestionImages() {
  if (instalado) return
  instalado = true

  document.addEventListener("click", (event) => {
    const alvo = event.target as HTMLElement
    if (alvo?.tagName === "IMG" && alvo.classList.contains("questao-figura")) {
      abrirZoom(alvo as HTMLImageElement)
    }
  })

  // 'error' não borbulha — só pega na fase de captura.
  document.addEventListener(
    "error",
    (event) => {
      const alvo = event.target as HTMLElement
      if (alvo?.tagName === "IMG" && alvo.classList.contains("questao-figura")) {
        figuraIndisponivel(alvo as HTMLImageElement)
      }
    },
    true
  )
}
